import React from 'react';


const BrandingStateContext = React.createContext({
  rendered: false,
  setRendered: () => null,
});

export default BrandingStateContext;


export class BrandingStateProvider extends React.PureComponent {
  constructor(props) {
    super(props);

    this.setRendered = newState => {
      this.setState({ rendered: newState }, () => {
        if (!process.env.BROWSER_RUNTIME || !newState) return;
        document.querySelector('.ad-site-wrapper').style.maxWidth = '1080px';
      });
    };

    this.state = {
      rendered: false,
      setRendered: this.setRendered,
    };
  }

  render() {
    return (
      <BrandingStateContext.Provider value={this.state}>
        {this.props.children}
      </BrandingStateContext.Provider>
    );
  }
}

export function withBrandingState(Component) {
  return function BrandingStateConsumer(props) {
    return (
      <BrandingStateContext.Consumer>
        {brandingState => {
          return <Component brandingState={brandingState} {...props}  />;
        }}
      </BrandingStateContext.Consumer>
    );
  };
}
